import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component={"span"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down('md')]: {
      width: "100%",
    },
    backgroundColor: "transparent",
    boxShadow: "none",
    color: theme.palette.primary.main,
    fontWeight: "bold",
    width: "85%",
    zIndex: 0,
  },
  tab: {
    fontWeight: "bold",
    [theme.breakpoints.down('md')]: {
      "& .MuiBox-root": {
        padding: "0px",
      },
    },
    color: theme.palette.primary.main,
  },
  largeIcon: {
    color: theme.palette.primary.main,
    margin: "auto",
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
  },
  tabContainer: {
    marginLeft: "24px",
  },
  primary: {
    backgroundColor: theme.palette.primary.main,
  },
}));

export default function TabbedView({ tabs }) {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <AppBar position="static" className={classes.root}>
        <Tabs
          value={value}
          onChange={handleChange}
          classes={{ indicator: classes.primary }}
          className={classes.tabContainer}
          variant="scrollable"
          allowScrollButtonsMobile
        >
          {tabs.map((tab, index) => (
            <Tab
              label={tab.title}
              {...a11yProps(index)}
              className={classes.tab}
            />
          ))}
        </Tabs>
      </AppBar>
      {tabs.map((tab, index) => (
        <TabPanel value={value} index={index} className={classes.tab}>
          {tab.component}
        </TabPanel>
      ))}
    </>
  );
}
